export default [{
  name: 'id',
  path: '/id',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/id/Id.vue').default
}]
